import { AfterViewInit, Directive, Input, OnDestroy, OnInit } from "@angular/core";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import {
    DashboardResourceService,
    IDashboardRequestUrlParts
} from "libraries/service/resources/dashboard/dashboard-resource.service";
import { IDashboardConfigData } from "libraries/interfaces/i-dashboard-config";
import * as echarts from "echarts";
import { EChartsType } from "echarts";
import { NotificationType } from "libraries/interfaces/INotification";
import { switchMap } from "rxjs/operators";
import { Observable, of, Subscription } from "rxjs";
import { ILoader } from "libraries/component/loader/ILoader";
import { Yii } from "libraries/interfaces/Yii";
import { LoaderType } from "libraries/component/loader/loader.component";
import { NameValueType } from "@afidium/ts-facade";
import { LocalizedPipe } from "libraries/pipes/localized/localized.pipe";

@Directive()
export abstract class GenericGraph implements OnInit, AfterViewInit, OnDestroy {
    @Input()
    public config: IDashboardConfigData;
    @Input()
    public index: string;

    public id: string;

    public name: string;
    public chart: EChartsType;


    public displayError: boolean = false;
    public error: string = "";

    public title: string = "";
    public xAxis: string = "";
    public yAxis: string = "";
    public notificationType: NotificationType = NotificationType.Info;
    public loader: ILoader = {
        active: false,
        message: Yii.t('wui-dashboard-js', 'Recherche en cours...'),
        type: LoaderType.large,
    };
    private subscription: Subscription;

    constructor(
        public searchParameterService: SearchParameterService,
        public dashboardResource: DashboardResourceService,
        public localizedPipe : LocalizedPipe
    ) {
    }

    public ngOnInit(): void {
        this.id = (Math.random() + 1).toString(36).substring(2);
        this.title = this.replaceAPS(this.config.titleArray || this.config.title);
        this.xAxis = this.replaceAPS(this.config.xaxisArray || this.config.xaxis);
        this.yAxis = this.replaceAPS(this.config.yaxisArray || this.config.yaxis);
    }

    public ngAfterViewInit(): void {
        let chartDom = document.getElementById(this.id);
        this.chart = echarts.init(chartDom);
        this.request();
    }

    public replaceAPS(val: string | NameValueType[]): string {
        if (val && typeof val === "string") {
            return val.replace("***", "'");
        }
        if(Array.isArray(val)){
            return this.localizedPipe.transform(val);
        }
        return "";
    }

    public resize() {
        this.chart.resize();
    }

    public request(): void {
        this.loader.active = true;

        if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }
        this.subscription =
            of({
                req: this.config.req,
                type: this.config.type,
                index: this.index,
                ...this.searchParameterService.getSearchParams(),
            })
                .pipe(
                    switchMap((request: IDashboardRequestUrlParts): Observable<any> => {
                        return this.dashboardResource.search(request);
                    }),
                )
                .subscribe({
                    next: (val: any): void => {
                        this.loader.active = false;
                        this.displayError = false;
                        this.draw(val);
                        this.resize();
                    },
                    error: (err: any): void => {
                        console.log(err)
                        this.loader.active = false;
                        this.chart.clear();
                        this.displayError = true;
                        this.notificationType = NotificationType.Error;
                        this.error = err.data.message;
                    }
                });

    }

    public ngOnDestroy(): void {
        if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }
    }


    protected draw(data: any): void {
    }

}
